export default {
  idc_right: false,
  idc_left: false,
  type: "DAY_SPLINT",
  idc_schematic_short: false,
  idc_schematic_whole_leg: false,
  idc_schematic_dif_views: false,
  idc_exterior_finishing: false,
  exterior_finishing_type: null,
  pp: null,
  polystone: null,
  exterior_finishing_other: null,
  transfer_id: null,
  idc_interior_finishing: false,
  interior_finishing_type: null,
  interior_finishing_other: null,
  skin: null,
  thermo_color_id: null,
  thickness: null,
  ankle: null,
  knee: null,
  articulation_other: null,
  idc_reminder: false,
  idc_lock: false,
  idc_slipper: false,
  idc_knee_sling: false,
  addition_other: null,
  s1_color_id: null,
  s1_size: null,
  s1_type: null,
  s1_cushion: null,
  s2_color_id: null,
  s2_size: null,
  s2_type: null,
  s2_cushion: null,
  s3_color_id: null,
  s3_size: null,
  s3_type: null,
  s3_cushion: null,
  s4_color_id: null,
  s4_size: null,
  s4_type: null,
  s4_cushion: null,
  s5_color_id: null,
  s5_size: null,
  s5_type: null,
  s5_cushion: null,
  s6_color_id: null,
  s6_size: null,
  s6_type: null,
  s6_cushion: null,
  s7_color_id: null,
  s7_size: null,
  s7_type: null,
  s7_cushion: null,
  comment: null,
  part_to_order: null,
  other_lpr: null,
  schematic_short_left_a: null,
  schematic_short_left_b: null,
  schematic_short_left_c: null,
  schematic_short_left_d: null,
  schematic_short_left_e: null,
  schematic_short_left_f: null,
  schematic_short_right_a: null,
  schematic_short_right_b: null,
  schematic_short_right_c: null,
  schematic_short_right_d: null,
  schematic_short_right_e: null,
  schematic_short_right_f: null,
  schematic_short_g: null,
  schematic_whole_leg_a2: null,
  schematic_whole_leg_a3: null,
  schematic_whole_leg_a4: null,
  schematic_whole_leg_b2: null,
  schematic_whole_leg_b3: null,
  schematic_whole_leg_b4: null,
  schematic_whole_leg_c1: null,
  schematic_whole_leg_c2: null,
  schematic_whole_leg_c4: null,
  schematic_whole_leg_c5: null,
  blob_cut_out: null,
  blob_sketch: null,
  articles: []
};
